import React, { MutableRefObject, useEffect, useState } from 'react';
import Keyboard from 'react-simple-keyboard';

import { shiftFilledIcon, shiftIcon } from '../../assets';

interface CustomKeyboardProps {
  input: string;
  onChange: (val: string) => void;
  keyboardRef: MutableRefObject<any>;
  onEnter?: () => void;
}

export const CustomKeyboard: React.FC<CustomKeyboardProps> = ({
  input,
  onChange,
  keyboardRef,
  onEnter,
}) => {
  const [layoutName, setLayoutName] = useState('default');

  useEffect(() => {
    if (keyboardRef.current) {
      keyboardRef.current.setInput(input || '');
    }
  }, [input, keyboardRef]);

  const handleKeyPress = (button) => {
    if (button === '{shift}') {
      setLayoutName((prev) => (prev === 'default' ? 'shift' : 'default'));
    }
    if (button === '{?123}') {
      setLayoutName((prev) => (prev === 'numbers' ? 'default' : 'numbers'));
    }
    if (button === '{enter}' && typeof onEnter === 'function') {
      onEnter();
    }
  };

  return (
    <Keyboard
      keyboardRef={(r) => (keyboardRef.current = r)}
      input={input}
      onChange={onChange}
      layoutName={layoutName}
      onKeyPress={handleKeyPress}
      layout={{
        default: [
          'q w e r t y u i o p {bksp}',
          'a s d f g h j k l {enter}',
          '{shift} z x c v b n m ! ? {shift}',
          '{?123} , {space} . {?123}',
        ],
        shift: [
          'Q W E R T Y U I O P {bksp}',
          'A S D F G H J K L {enter}',
          '{shift} Z X C V B N M ! ? {shift}',
          '{?123} , {space} . {?123}',
        ],
        numbers: [
          '1 2 3 4 5 6 7 8 9 0 {bksp}',
          '@ # $ _ & - + ( ) {enter}',
          '{shift} * " \' : ; ! ? {shift}',
          '{?123} , {space} . {?123}',
        ],
      }}
      display={{
        '{bksp}': '⌫',
        '{enter}': `<img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMSIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMxIDMyIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMi4wNDQ5MiAxNi4yNUgyOC43NjM3TTI4Ljc2MzcgMTYuMjVMMTguOTE5OSA2LjQwNjI1TTI4Ljc2MzcgMTYuMjVMMTguOTE5OSAyNi4wOTM4IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=" style="width:32px;height:32px;vertical-align:middle;" />`,
        '{shift}': `<img src="${layoutName === 'shift' ? shiftFilledIcon : shiftIcon}" style="width:32px;height:32px;vertical-align:middle;" />`,
        '{space}': ' ',
        '{?123}': '?123',
      }}
    />
  );
};
